import React from "react";
import { Button, Icon } from "react-materialize";
import handleEvents from "components/notify/handleEvents";
import { useNotify } from "context/NotifyContext";

export default function BtnAddByEmail() {
  const { filters, dispatch } = useNotify();
  return (
    <Button
      flat
      node="button"
      waves="light"
      className="btn-top-right textcolor-green"
      id="btn-add-by-email"
      onClick={() =>
        handleEvents.BtnAddNewByEmail.OnOpenDialog(filters, dispatch)
      }
    >
      Add New By Email
      <Icon right>email</Icon>
    </Button>
  );
}
